import axios from 'axios'
import baseURL from './useBaseURL'

export default axios.create({ baseURL })
